var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle-text",attrs:{"id":_vm.id}},[_c('label',{staticClass:"subtitle-label-text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }